import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";

const languageSelectorStyle = css`
  display: flex;
  gap: 4px;
  margin-left: 12px;
`;

const languageSelectorBtn = css`
  padding: 4px 10px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: var(--radius-sm);
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.8rem;
  font-family: var(--font-heading);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    color: #FFFFFF;
  }
`;

const languageSelectorBtnActive = css`
  background: rgba(255, 255, 255, 0.15);
  color: #FFFFFF;
  border-color: transparent;
`;

const LANGUAGES = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
] as const;

export function LanguageSelector() {
  const { i18n } = useTranslation();

  return (
    <div css={languageSelectorStyle}>
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          css={[languageSelectorBtn, i18n.language === code && languageSelectorBtnActive]}
          onClick={() => i18n.changeLanguage(code)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
